import { categoriesRegExp } from './pages/Education/categories'
import loadable from '@loadable/component'
import React from 'react'

const Home = loadable(() =>
  import(/* webpackChunkName: "Home" */ './pages/Home/Home')
)
const SignUpPage = loadable(() =>
  import(/* webpackChunkName: "SignUpPage" */ './pages/SignUpPage')
)
const BlogPostPage = loadable(() =>
  import(/* webpackChunkName: "BlogPostPage" */ './pages/Blog/BlogPostPage')
)
const ArticlePage = loadable(() =>
  import(
    /* webpackChunkName: "ArticlePage" */ './pages/CMSTemplates/ArticlePage'
  )
)
const NativeAdsRouter = loadable(() =>
  import(
    /* webpackChunkName: "NativeAdsRouter" */ './components/NativeAdsRouter'
  )
)
const BlogStartPage = loadable(() =>
  import(/* webpackChunkName: "BlogStartPage" */ 'js/pages/Blog/BlogStartPage')
)
const BlogCategoryPage = loadable(() =>
  import(
    /* webpackChunkName: "BlogCategoryPage" */ 'js/pages/Blog/BlogCategoryPage'
  )
)
const CategoryPage = loadable(() =>
  import(
    /* webpackChunkName: "CategoryPage" */ 'js/pages/CMSTemplates/CategoryPage'
  )
)
const EducationStartPage = loadable(() =>
  import(
    /* webpackChunkName: "EducationStartPage" */ 'js/pages/Education/EducationStartPage'
  )
)
const PremiumPage = loadable(() =>
  import(
    /* webpackChunkName: "PremiumPage" */ './pages/PremiumPage/PremiumPage'
  )
)
const ContactUsPage = loadable(() =>
  import(
    /* webpackChunkName: "ContactUsPage" */ './pages/ContactUs/ContactUsPage'
  )
)
const PrivacyPolicy = loadable(() =>
  import(/* webpackChunkName: "PrivacyPolicy" */ './pages/policy/PrivacyPolicy')
)
const PrivacyPolicyDE = loadable(() =>
  import(
    /* webpackChunkName: "PrivacyPolicyDE" */ './pages/policy/PrivacyPolicyDE'
  )
)
const AmbassadorSwePage = loadable(() =>
  import(
    /* webpackChunkName: "AmbassadorSwePage" */ './pages/AmbassadorSwePage/AmbassadorSwePage'
  )
)
const ContentfulNativeAd = loadable(() =>
  import(
    /* webpackChunkName: "ContentfulNativeAd" */ './pages/ContentfulNativeAd.js'
  )
)
const MealPlansPage = loadable(() =>
  import(
    /* webpackChunkName: "MealPlansPage" */ './pages/MealPlansPage/MealPlansPage'
  )
)

const GetInContact = loadable(() =>
  import(/* webpackChunkName: "GetInContact" */ './pages/GetInContact')
)

const Page = loadable(() =>
  import(/* webpackChunkName: "Page" */ './pages/Page')
)

const clientRoutes = []
const routes = [
  {
    path: '/',
    component: Home,
    exact: true,
    translated: true,
  },
  {
    path: '/signup',
    component: SignUpPage,
  },
  {
    path: '/contact',
    component: ContactUsPage,
  },
  {
    path: '/get-in-contact',
    component: GetInContact,
  },
  {
    path: '/policy',
    component: PrivacyPolicy,
  },
  {
    path: '/policy-de',
    component: PrivacyPolicyDE,
  },
  {
    path: '/ambassadorswe',
    component: AmbassadorSwePage,
  },
  {
    path: '/ketoapp',
    // eslint-disable-next-line
    component: function ContentfulNativeAdRoute({ match }) {
      return (
        <ContentfulNativeAd match={{ ...match, params: { slug: 'ketoapp' } }} />
      )
    },
    translated: true,
  },
  {
    path: '/three-week-weight-loss',
    // eslint-disable-next-line
    component: function ContentfulNativeAdRoute({ match }) {
      return (
        <MealPlansPage
          match={{
            ...match,
            params: { slug: 'three-week-weight-loss' },
          }}
        />
      )
    },
    translated: true,
  },
  {
    path: '/sugar-detox',
    // eslint-disable-next-line
    component: function ContentfulNativeAdRoute({ match }) {
      return (
        <MealPlansPage
          match={{
            ...match,
            params: { slug: 'sugar-detox' },
          }}
        />
      )
    },
    translated: true,
  },
  {
    path: '/paleo',
    // eslint-disable-next-line
    component: function ContentfulNativeAdRoute({ match }) {
      return (
        <MealPlansPage
          match={{
            ...match,
            params: { slug: 'paleo' },
          }}
        />
      )
    },
    translated: true,
  },
  { path: '/premium', component: PremiumPage },
  { path: '/blog', component: BlogStartPage, exact: true },
  { path: '/blog/page/:slug', component: BlogStartPage },
  {
    path: '/blog/author/:author/:page?/:pageNumber?',
    component: BlogCategoryPage,
  },
  {
    path: '/blog/category/:category/:page?/:pageNumber?',
    component: BlogCategoryPage,
  },
  { path: '/blog/tags/:tag/:page?/:pageNumber?', component: BlogCategoryPage },
  { path: '/blog/:slug', component: BlogPostPage },
  { path: '/news/:slug', component: NativeAdsRouter, translated: true },
  { path: '/health/:slug', component: NativeAdsRouter },
  { path: '/fitness', component: CategoryPage },
  { path: '/food', component: CategoryPage },
  { path: '/health-education', component: EducationStartPage, exact: true },
  {
    path: `/health-education/:category(${categoriesRegExp})`,
    component: CategoryPage,
  },
  { path: '/:category/:slug', component: ArticlePage },
  { path: '/:slug', component: Page },
]

export { clientRoutes }

export default routes
